import I18n from 'i18n-js';
import formatCurrency from './format-currency';

export const cumulateFare = (cumulatedFares, key, fare) => {
  const cumulatedFare = cumulatedFares[key];

  if (!fare) {
    if (cumulatedFare) {
      cumulatedFare.valid = false;
    }
    return;
  }

  if (!cumulatedFare) {
    cumulatedFares[key] = fare;
    return;
  }

  cumulatedFare.amount += fare.amount;
  cumulatedFare.fareFrom = cumulatedFare.fareFrom || fare.fareFrom;
  cumulatedFare.valid = cumulatedFare.valid && fare.valid;
};

export const displayCumulatedFare = cumulatedFare => {
  if (!cumulatedFare || !cumulatedFare.valid || !cumulatedFare.currency) {
    return '';
  }

  const fare = formatCurrency({
    code: cumulatedFare.currency.code,
    amount: cumulatedFare.amount,
  });

  if (!cumulatedFare.fareFrom) {
    return fare;
  }

  return I18n.t('bulkUploadRevamp.overlay.fareFrom', { fare });
};
